<template>
  <div
  class="group relative backdrop-blur border border-slate-700 hover:border-yellow-400 rounded-2xl p-8 transition-all duration-300 overflow-hidden hover:bg-opacity-70"
  :class="index % 2 === 0 ? 'lg:translate-y-0' : 'lg:translate-y-8'"
  :style="{ backgroundColor: 'rgba(15, 23, 42, 0.5)' }"
>

    <!-- Hover gradient overlay -->
    <div
      class="absolute inset-0 opacity-0 group-hover:opacity-10 transition-opacity duration-300 -z-10"
      :style="{
        background: 'linear-gradient(to bottom right, #3b82f6, transparent, transparent)'
      }"
    />

    <!-- Accent line -->
    <div
      class="absolute left-0 top-0 h-1 w-12"
      :style="{ backgroundColor: '#facc15' }"
    />

    <!-- Content -->
    <h3 class="text-2xl font-bold text-white mb-3">
      {{ title }}
    </h3>

    <p class="text-gray-300 mb-6 leading-relaxed">
      {{ description }}
    </p>

    <!-- Highlights -->
    <div class="space-y-3">
      <div
        v-for="(highlight, i) in highlights"
        :key="i"
        class="flex items-start gap-3"
      >
        <div
          class="h-1.5 w-1.5 rounded-full mt-2 flex-shrink-0"
          :style="{ backgroundColor: '#facc15' }"
        />
        <span class="text-gray-300">
          {{ highlight }}
        </span>
      </div>
    </div>

    <!-- Footer -->
    <div class="mt-6 pt-6 border-t" :style="{ borderColor: '#334155' }">
      <button   @click="scrollMeTo(scrollname)"
        class="inline-flex items-center gap-2 font-semibold transition-all hover:gap-3"
        :style="{ color: '#facc15' }"
      >
        Learn More <span>→</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    scrollname: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    highlights: {
      type: Array,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  methods: {
    scrollMeTo(selector) {
      const el = document.querySelector(selector)
      if (el) {
        window.scrollTo({
          top: el.offsetTop,
          behavior: "smooth",
        })
      }
    },
  },

}
</script>
